import React, { Component } from 'react';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import AccountMasterServices from '../../../services/axiosServices/apiServices/AccountMasterServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { CommonValidationMessages } from '../../../utils/Messages';
import { ChequeBookMasterPopup } from './ChequeBookMasterTable';
import { ChequeBookIteamPopup } from './ChequeBookIteamPopup';
import moment from 'moment';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class ChequeBookMaster extends Component {
    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.accountMasterServices = new AccountMasterServices();
        this.SwalServices = new SwalServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            isModalOpenForAddItem: false,
            rowData: [],
            colDefs: [],
            table2Data: [],
            table2ColDefs: [],
            isTable2Expanded: false,
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            chequeObject: {
                idChequeBookMaster: 0,
                updateStatus: 0,
                idBank: 0,
                date: "",
                chequeBookSeriesFrom: "",
                chequeBookSeriesTo: "",
                e_Date: "",
                itemList: [
                    // {
                    //     id: 1,
                    //     chequeBookNo: "1001",
                    //     isCancel: true,
                    //     remarks: "Test1",
                    //     idChequeBookDetails: 0,
                    // },
                    // {
                    //     id: 2,
                    //     chequeBookNo: "1002",
                    //     isCancel: false,
                    //     remarks: "Test2",
                    //     idChequeBookDetails: 0,
                    // }
                ],
                bankList: [],
                deleteItemsList: [],
            },
            itemObject: {
                id: 0,
                chequeBookNo: "",
                isCancel: false,
                remarks: "",
                idChequeBookDetails: 0,
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                idBank: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "bank"
                        ),
                    },
                ],
                date: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "date"
                        ),
                    },
                ],
            },
            validationRulesForChequeSeries: {
                chequeBookSeriesFrom: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "cheque book series from"
                        ),
                    },
                    {
                        type: "number",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "number"
                        ),
                    },
                    {
                        type: "maxNumber",
                        compareEle: "chequeBookSeriesTo",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "number"
                        ),
                    },
                ],
                chequeBookSeriesTo: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "cheque book series to"
                        ),
                    },
                    {
                        type: "number",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "number"
                        ),
                    },
                    {
                        type: "minNumber",
                        compareEle: "chequeBookSeriesFrom",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "number"
                        ),
                    },
                ],
            },
            validStateForChequeSeries: {
                isValid: true,
                error: {},
            },
        }
    }

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.setState({ isModalOpen: true }, () => {
            this.resetDetailsFields();
            //this.getMasterExpenseAccGroupCount();
        })
    };

    handleCellClick = (event) => {
        this.procSelectAllRecord2GridviewSP(event.data.idChequeBookMaster);
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.getMasterChequeBookSelectbyId(event.data.idChequeBookMaster);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    handleCellClickItemList = (event) => {
        //this.getMasterChequeBookSelectbyId(event.data.idChequeBookMaster);
        //let validState = this.state.validState;
        //validState.isValid = true;
        //validState.error = {};
        let data = this.state.chequeObject.itemList[event.data.id - 1];
        let obj = this.state.itemObject;
        obj.id = data.id;
        obj.chequeBookNo = data.chequeBookNo;
        obj.isCancel = data.isCancel;
        obj.remarks = data.remarks;
        obj.idChequeBookDetails = data.idChequeBookDetails;
        this.setState({
            itemObject: obj,
            isModalOpenForAddItem: true,
        });
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.chequeObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    setOpenModelForItem = () => {
        this.setState({ isModalOpenForAddItem: !this.state.isModalOpenForAddItem });
    };

    closePopupForItem = () => {
        this.setState({ isModalOpenForAddItem: false, });
    };

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.chequeObject;
        details[name] = value;
        this.setState({ chequeObject: details });
    }

    getPinnedWidth = (key) => {
        // const pinnedCol = {
        //     "idCashWithdraw": window.innerWidth * 0.06,
        //     "sR.No": window.innerWidth * 0.04,
        //     "employeeName": window.innerWidth * 0.18,
        // }
        // return pinnedCol[key]
    }

    handleChangeFroDropdown = (event, name) => {
        let details = this.state.chequeObject;
        let value = event.value;
        details[name] = value;
        this.setState({ chequeObject: details });
    }

    handleChangeForChequeBookItem = (event, name) => {
        let value = event.target.value;
        let details = this.state.itemObject;
        if (name === 'isCancel') {
            details.isCancel = !details.isCancel;
        } else {
            details[name] = value;
        }
        this.setState({ itemObject: details });
    }

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let chequeObject = this.state.chequeObject;
        chequeObject.idChequeBookMaster = 0;
        chequeObject.updateStatus = 0;
        chequeObject.idBank = 0;
        chequeObject.date = "";
        chequeObject.chequeBookSeriesFrom = "";
        chequeObject.chequeBookSeriesTo = "";
        chequeObject.e_Date = "";
        chequeObject.itemList = [];
        this.setState({
            chequeObject: chequeObject, validState: validState
        });
    }

    componentDidMount = () => {
        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                this.procSelectAllRecordsSP();
                this.getMasterBankSelect();
            });
        } else {
            // window.location.href = "/Login";
        } setTimeout(() => {
            //this.removeDefaultBorders();
        }, 100);
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Cheque Book Master",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
            //idFinancialYear : null,
            //idPlant : 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                //debugger;
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idChequeBookMaster"].includes(key) ? true : false,
                            width: this.getPinnedWidth(key),
                            valueGetter: (params) => params.data[key],
                            // valueFormatter: key.includes("date") || key.includes("invoiceDate")
                            //   ? (params) => {
                            //     if (!params.value) return "";
                            //     return moment(params.value).format("DD-MM-YYYY");
                            //   }
                            //   : undefined,
                            //pinned: ["idBank", "sR.No", "employeeName"].includes(key) ? "left" : null,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs, //updatedColDefs,
                            caption: "Cheque Book Master",
                            colName: colName
                        }, () => {
                            this.procSelectAllRecord2GridviewSP(id);
                            //this.getAllDropdownForEmployeeMaster();
                            this.setPermissions(permissions);
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                            //this.getAllDropdownForEmployeeMaster();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    procSelectAllRecord2GridviewSP = (id) => {
        let request = {
            id: id,
            formname: "Cheque Book Master",
            //idCompany: this.state.prop.idCompany
        }
        this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                const dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                        field: key,
                        headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                        flex: 1
                    }));
                    this.setState({
                        table2Data: dynamicData,
                        table2ColDefs: dynamicColDefs,
                        isTable2Expanded: true
                    });
                } else {
                    this.setState({
                        table2Data: [],
                        table2ColDefs: [],
                        isTable2Expanded: false,
                    });
                }
            }
        });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "sR.No": window.innerWidth * 0.05,
            "bankName": window.innerWidth * 0.4,
            "chequeBookSeries": window.innerWidth * 0.25,
        }
        return colwidth[key]
    }

    // getMasterExpenseAccGroupCount = () => {
    //     this.accountMasterServices.getMasterExpenseAccGroupCount(this.state.idCompany).then((response) => {
    //         //debugger
    //         if (response.statusCode == 200 && response.responseItem !== null) {
    //             let data = response.responseItem.responseContent[0].count;
    //             let chequeObject = this.state.chequeObject
    //             chequeObject.accGrpNo = data + 1;
    //             this.setState({
    //                 chequeObject: chequeObject
    //             });
    //         }
    //     });
    // }

    getMasterBankSelect = () => {
        this.accountTransactionServices.usp_Master_BankSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                dynamicData = dynamicData.map((x) => ({
                    value: x.idBank,
                    label: x.bankName,
                }));
                let object = this.state.chequeObject;
                object.bankList = dynamicData
                this.setState({
                    chequeObject: object
                });
            }
        });
    }

    getMasterChequeBookSelectbyId = (id) => {
        this.accountMasterServices.getMasterChequeBookSelectbyId(id).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent[0];
                let chequeObject = this.state.chequeObject;
                chequeObject.idChequeBookMaster = data.idChequeBookMaster;
                chequeObject.updateStatus = 1;
                chequeObject.idBank = data.idBank;
                chequeObject.date = moment(data.date).format('YYYY-MM-DD');
                if (data.chequeBookSeries) {
                    const seriesParts = data.chequeBookSeries.split(' to ');

                    chequeObject.chequeBookSeriesFrom = seriesParts[0];
                    chequeObject.chequeBookSeriesTo = seriesParts[1];
                }
                chequeObject.e_Date = data.e_Date;
                this.setState({
                    chequeObject: chequeObject
                }, () => {
                    this.accountMasterServices.getMasterChequeBookListSelectbyId(id).then((response2) => {
                        if (response2.statusCode == 200 && response2.responseItem !== null) {
                            let res = response2.responseItem.responseContent;
                            let object = this.state.chequeObject;
                            object.itemList = [];
                            if (res.length > 0) {
                                res.map((x, key) => {
                                    let obj = {
                                        id: key + 1,
                                        chequeBookNo: x.chequeNo,
                                        isCancel: x.isCancel,
                                        remarks: x.remarks,
                                        idChequeBookDetails: x.idChequeBookDetails,
                                        //cancelDate: moment(x.cancelDate).format('YYYY-MM-DD'),
                                    }
                                    object.itemList.push(obj);
                                })
                            }
                            this.setState({
                                isModalOpen: true,
                                chequeObject: object
                            });
                        }
                    });
                });
            }
        });
    }

    addItem = () => {
        this.resetItemObject();
        this.setState({ isModalOpenForAddItem: !this.state.isModalOpenForAddItem });
    }

    insertItem = (id) => {
        const { chequeObject, itemObject } = this.state;
        let newItemList = [...chequeObject.itemList];

        if (id > 0) {
            newItemList[id - 1] = { ...itemObject };
        } else {
            newItemList.push({ ...itemObject });
        }

        newItemList = newItemList.map((item, index) => ({
            ...item,
            id: index + 1,
        }));

        this.setState({
            chequeObject: {
                ...chequeObject,
                itemList: newItemList,
            },
            isModalOpenForAddItem: false,
        }, () => {
            this.resetItemObject();
        });
    };

    deleteItem = (id) => {
        let data = this.state.chequeObject;
        let idChequeBookDetails = data.itemList.find(item => item.id == id)?.idChequeBookDetails;
        let updatedChequeBooksList = data.itemList.filter(item => item.id !== id);
        if (updatedChequeBooksList.length > 0) {
            updatedChequeBooksList.map((x, key) => {
                x.id = key + 1;
            });
        }
        data.itemList = updatedChequeBooksList;
        data.deleteItemsList.push(idChequeBookDetails);
        this.setState({ chequeObject: { ...data }, isModalOpenForAddItem: false }, () => {
            this.resetItemObject();
        });
    }

    resetItemObject = () => {
        let reset = this.state.itemObject
        reset.id = "";
        reset.chequeBookNo = "";
        reset.isCancel = false;
        reset.remarks = "";
        reset.idChequeBookDetails = "";
        this.setState({ itemObject: reset });
    }

    submit = () => {
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            let details = this.state.chequeObject;
            let requestData = {
                idChequeBookMaster: details.idChequeBookMaster,
                idBank: details.idBank,
                chequeBookSeries: details.chequeBookSeriesFrom + ' to ' + details.chequeBookSeriesTo,
                date: details.date,
                e_User: this.state.idUser,
                e_Date: details.e_Date && details.e_Date !== 'Invalid date' ? details.e_Date : new Date().toISOString(),
                isUpdated: details.updateStatus === 1 ? true : null,
                updatedDate: details.updateStatus === 1 ? new Date().toISOString() : null,
                isDeleted: false,
                deletedDate: null,
                idCompany: this.state.idCompany,
            };
            details.itemList.map((x) => {
                x.chequeNo = x.chequeBookNo;
                x.ISUsed = 0;
                x.idChequeBookDetails = x.idChequeBookDetails > 0 ? x.idChequeBookDetails : 0;
                //x.isCancel = x.isCancel;
                x.cancelDate = x.isCancel === true ? new Date().toISOString() : null;
                //x.remarks = x.remarks;
            })
            requestData.itemListForChequeBook = details.itemList;
            requestData.deleteItemsList = details.deleteItemsList;
            this.accountMasterServices.submitChequeMaster(requestData)
                .then((response) => {
                    if (response.statusCode == 200 && response.responseItem !== null) {
                        let dynamicData = response.responseItem.responseContent;
                        if (dynamicData !== null) {
                            if (response.responseItem?.responseContent?.errorType === 'Exists') {
                                this.SwalServices.Error("Cheque number are already exists");
                            } else {
                                if (this.state.chequeObject.updateStatus === 1) {
                                    this.SwalServices.Success("Updated successfully.");
                                } else {
                                    this.SwalServices.Success("Saved successfully.");
                                }
                                this.resetDetailsFields();
                                // Call resetFields here after submission
                                this.setState(
                                    { isModalOpen: false },
                                    () => {
                                        this.procSelectAllRecordsSP(); // Fetch latest records
                                    }
                                );
                            }

                        } else {
                            this.procSelectAllRecordsSP();
                        }
                    } else {
                        this.setState(
                            { isModalOpen: false },
                            () => {
                                this.SwalServices.Error(response.message);
                                this.procSelectAllRecordsSP(); // Fetch latest records
                            }
                        );
                    }
                });
        }
    };

    isValidAllFieldsForChequeSeries = () => {
        const newValidState = isValidForm(
            this.state.chequeObject,
            this.state.validationRulesForChequeSeries,
            this.state.validStateForChequeSeries,
        );
        this.setState({ validStateForChequeSeries: newValidState });
        return newValidState.isValid;
    }

    generateAutoChequeNO = () => {
        let isValid = this.isValidAllFieldsForChequeSeries();
        if (!isValid) return;

        const { chequeBookSeriesFrom, chequeBookSeriesTo, itemList } = this.state.chequeObject;

        let start = parseInt(chequeBookSeriesFrom, 10);
        let end = parseInt(chequeBookSeriesTo, 10);

        if (isNaN(start) || isNaN(end)) {
            alert("Invalid cheque series");
            return;
        }

        if (start > end) {
            alert("Start cheque no cannot be greater than end cheque no");
            return;
        }

        let newRows = [];

        for (let i = start; i <= end; i++) {

            let chequeNo = i.toString();

            const exists = itemList.some(x => Number(x.chequeBookNo) === i);
            if (exists) continue;

            newRows.push({
                id: itemList.length + newRows.length + 1,
                chequeBookNo: chequeNo,
                isCancel: false,
                remarks: "",
                idChequeBookDetails: 0
            });
        }

        let chequeObject = this.state.chequeObject;
        chequeObject.itemList = newRows;

        this.setState({
            chequeObject: chequeObject,
        });
    }

    render() {
        return (
            <div className='company-master'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print', 'delete']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                                delete: this.handleDelete,
                            }}
                        />
                        <ChequeBookMasterPopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            chequeObject={this.state.chequeObject}
                            handleChange={this.handleChange.bind(this)}
                            close={this.closePopup.bind(this)}
                            submit={this.submit.bind(this)}
                            addItem={this.addItem.bind(this)}
                            handleChangeFroDropdown={this.handleChangeFroDropdown.bind(this)}
                            validState={this.state.validState}
                            handleCellClickItemList={this.handleCellClickItemList}
                            generateAutoChequeNO={this.generateAutoChequeNO}
                            validStateForChequeSeries={this.state.validStateForChequeSeries}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px] mb-5">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 296px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Cheque book master</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onCellClicked={this.handleCellClick}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.table2Data}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.table2ColDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>
                        <ChequeBookIteamPopup
                            isModalOpen={this.state.isModalOpenForAddItem}
                            setOpenModel={this.setOpenModelForItem.bind(this)}
                            itemObject={this.state.itemObject}
                            //handleChange={this.handleChange.bind(this)}
                            close={this.closePopupForItem.bind(this)}
                            insertItem={this.insertItem.bind(this)}
                            deleteItem={this.deleteItem.bind(this)}
                            handleChangeForChequeBookItem={this.handleChangeForChequeBookItem.bind(this)}
                            validState={this.state.validState}
                        />
                    </div>
                </div>
            </div>
        )
    }
}